export default "__VITE_ASSET__B8GJgJUS__ 400w, __VITE_ASSET__BvsyE1$Y__ 800w, __VITE_ASSET__CtKUlLn5__ 1024w";